<script>
  import { AlertCircle, CheckCircle2, LoaderCircle } from 'lucide-svelte';

  export let type = 'neutral';
  export let title = '';
  export let message = '';

  $: icon = type === 'error' ? AlertCircle : type === 'success' ? CheckCircle2 : LoaderCircle;
  $: tone =
    type === 'error'
      ? 'border-red-200 bg-red-50 text-red-700'
      : type === 'success'
        ? 'border-emerald-200 bg-emerald-50 text-emerald-700'
        : 'border-slate-200 bg-white text-slate-700';
</script>

<div class={`flex min-w-0 items-start gap-3 rounded-xl border px-4 py-3 shadow-sm ${tone}`}>
  <svelte:component this={icon} size={18} class={`mt-0.5 shrink-0 ${type === 'neutral' ? 'animate-spin text-slate-400' : ''}`} />

  <div class="min-w-0">
    {#if title}
      <p class="text-sm font-semibold">{title}</p>
    {/if}

    {#if message}
      <p class="text-sm">{message}</p>
    {:else}
      <slot />
    {/if}
  </div>
</div>
